define('GameDayCore/GDModel/ValueObjects/Plays/AtBat',['require','exports','module','../ValueObjectFactory','../../../GDControl/GameModelLocator/GameModelLocator','extant/extant','../../enums/baseball/PlayerTypes','./Pitch','gameday-resource-path/gameday-resource-path','../../../GDUtil/dataMapping/LocalizationUtil'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		GameModelLocator = require("../../../GDControl/GameModelLocator/GameModelLocator"),
        exists = require("extant/extant"),
        PlayerTypes = require("../../enums/baseball/PlayerTypes"),
        Pitch = require("./Pitch"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        LocalizationUtil = require("../../../GDUtil/dataMapping/LocalizationUtil");

	VO.create(AtBat, {
		getBatterModel: function() { 
			return this.gameItem.getPlayerSnapshot(this.batter, PlayerTypes.B);
		},
		getPitcherModel: function() { 
			return this.gameItem.getPlayerSnapshot(this.pitcher, PlayerTypes.P)
		},
		getBatterImage : function(){
			var model=this.getBatterModel();
			return model.getBatterImage.apply(model,arguments);
		}		
	});

	function AtBat($data, $inningnum) {
		var vo = VO.ensureVO(this, AtBat),
			data = $data,
			inningNum = $inningnum,
			pitches = parsePitches(data).reverse(),
			pitchesFull = [].concat(pitches),
			des = parseDescription(data),
			batter = data.batter,
			pitcher = data.pitcher,
			highlight = checkForHighlights(data,pitches);

		vo.gameItem = GameModelLocator.getCurrentGame();
		vo.homeScore = (data.score === "T" ? data.home_team_runs : "");
		vo.awayScore = (data.score === "T" ? data.away_team_runs : "");
		vo.inning = (!isNaN(data.inning) && parseInt(data.inning,10) !== 0) ? parseInt(data.inning,10) : inningNum;
		vo.isComplete = (typeof des === "string") ? (des.length > 0) : false;
		vo.pitches = pitches;
		vo.pitchesFull = pitchesFull;
		vo.numPitches = countPitches(data,pitches);
		vo.p_throws = (typeof data.p_throws === "string") ? data.p_throws.toUpperCase() : null;
		vo.halfInning = "";
		vo.abIndex = 0;
		vo.runners = {};
		vo.b = parseInt(data.b, 10) || 0;
		vo.s = parseInt(data.s, 10) || 0;
		vo.o = parseInt(data.o ,10) || 0;
		vo.batter = batter || "";
		vo.stand = "";
		vo.batterHeight = data.b_height||"";
		vo.pitcher = pitcher || "";
		vo.highlight = highlight;
		vo.hasHighlight = (exists(highlight));
		vo.type = data._nodeName || "";
		vo.des = des;
		vo.event = (typeof data.event === "string") ? data.event : "";
		vo.brief_event = data.brief_event || "";
		vo.score = data.score || "";
		vo.isScoringPlay = (data.score === "T");
		vo.isAction = (data._nodeName === "action");
		vo.isPlay = data._nodeName=== "atbat";
		vo.num = data.num || "";
		vo.atBatIDWithinHalfInning =  "";
		vo.startTfs = data.start_tfs || "";
		vo.start_tfs_zulu = data.start_tfs_zulu || "";
		vo.tfs = data.tfs || "";
		vo.tfs_zulu = data.tfs_zulu || "";
		vo.getTimestamp = getTimestamp;					
		if (vo.type === "atbat") {
			vo.batterMug = resourcePath.get('mugshot',{ pid : vo.batter});
			vo.pitcherMug = resourcePath.get('mugshot',{ pid : vo.pitcher});
		}

	}

	function parseDescription(data) {
		var val = (typeof data.des === "string") ? data.des : "";
		if (!LocalizationUtil.isEnglish()) {
			var localizedDes = data[("des_" + LocalizationUtil.language())];
			val = (typeof localizedDes === "string") ? localizedDes : val;
		}

		return val;
	}

	function checkForHighlights(data,pitches) {
		for (var i = 0, len = pitches.length; i < len; i++) {
            // leaving this as null, as we are not store or display pitches this way
			var vid = null;//model.ModelCache.retrieveRealTimeHighlight(pitches[i].sv_id);

			if (exists(vid)) {
				return highlight = vid;
			}
		}

		return null;
	}

	function parsePitches(data) {
		var ps = [],
			pitchObj,
            pitchLabelIdx = 0,
            strikes = 0,
            balls = 0;
		if (data._nodeName != "action" && exists(data._childList)) {

			for (var i = 0, len = data._childList.length; i < len; i++) {
				pitchObj = data._childList.get(i);
				if (pitchObj._nodeName == "runner") {
					//gonna do something with runner data eventually.
				} else {
					pitchObj.name = (pitchObj._nodeName === "p") ? "pitch" : pitchObj._nodeName;
					if (pitchObj.name === "pitch") {
						pitchLabelIdx++;
						pitchObj.idx = pitchLabelIdx;

						/*
						 * Build strike count while parsing all pitches
						 * "S" - Strike (Don't up count on foul with 2 stikes!)
						 * "B" - Ball
						 * "X" - Ball in play
						 */
						if(pitchObj.type === "S" && pitchObj.des !== "Foul" && pitchObj.des !== "Foul (Runner Going)"
							|| (pitchObj.des === "Foul" || pitchObj.des === "Foul (Runner Going)") && strikes < 2) {
							strikes++;
						} else if (pitchObj.type === "B") {
							balls++;
						} else if (pitchObj.type === "X") {
							pitchObj.isInPlay = true;
						}
						pitchObj.balls = balls;
						pitchObj.strikes = strikes;
					}

					var p = new Pitch(pitchObj);
					ps.push(p);
				}
			}
		}

		return ps;
	}

	function countPitches(data,pitches) {
		var count = 0;

		for (var i = 0, len = pitches.length; i < len; i++) {
			if (pitches[i].is_pitch) count++;
		}

		return count;
	}

	function getTimestamp(data) {
		var ts = "";

		for (var i = pitchesFull.length - 1; i >= 0; i--) {
			if (typeof pitchesFull[i].tfs_zulu === "string" && pitchesFull[i].tfs_zulu.length > 0) {
				ts = pitchesFull[i].tfs_zulu;
				break;
			}
		}

		if (ts === "") {
			if (typeof data.tfs_zulu === "string" && data.tfs_zulu.length > 0) {
				ts = data.tfs_zulu;
			} else {
				ts = data.start_tfs_zulu;
			}
		}

		return ts;
	};

	return AtBat;
});
